'use strict';

import clearForm from './clearForm';
import buildSubscriptionCategory from './buildSubscriptionCategory';

export default function form() {
    const AJAX_FORM_SELECTOR = '.js-ajax-form',
          AJAX_FORM_NEWSLETTER_SELECTOR = '.js-ajax-form-newsletter';

    let $form = $(AJAX_FORM_SELECTOR),
        $formNewsletter = $(AJAX_FORM_NEWSLETTER_SELECTOR);

    if ($form.length) {
        let msgTemplate = (state, message) => $([
            `<div class="alert alert-${state} t-a-c">`,
                message,
            `</div>`].join(''));

        let injectMsgs = ($parent, state, messages) => {
            messages.forEach((message) => msgTemplate(state, message).appendTo($parent));

            $parent.show();
        };

        $(document).on('submit', AJAX_FORM_SELECTOR, function (e) {
            e.preventDefault();

            let $this = $(this),
                data = $this.serialize(),
                clearParam = $this.attr('data-prevent-clear'),
                isNotCleared = typeof clearParam !== 'undefined' && clearParam === 'true',
                ajaxSettings = {
                    data: data || {},
                    dataType: $this.attr('data-type') || 'json',
                    method: $this.attr('method'),
                    url: $this.attr('action'),
                    success: (data) => {
                        let {error, success, messages, redirect} = data;

                        if (error) {
                            injectMsgs($msgHld, 'danger', [messages.join('<br>')] || []);
                        } else if (success) {
                            injectMsgs($msgHld, 'success', messages || []);
                            if (!isNotCleared) {
                                clearForm($this);
                            }

                            if (
                                typeof redirect !== 'undefined' &&
                                redirect
                            ) {
                                setTimeout(function() {
                                    window.location.href = redirect;
                                }, redirectAfter || 5000);
                            }
                        }
                    }
                },
                redirectAfter = $this.attr('data-redirect-after'),
                atLeastOneCheckbox = $this.attr('data-at-least-one-checkbox');

            if (
                typeof ajaxSettings.method === 'undefined' ||
                typeof ajaxSettings.url === 'undefined'
            ) {
                return;
            }

            let $msgHld = $this.find('.js-msg-hld');

            if (
                typeof atLeastOneCheckbox !== 'undefined' &&
                atLeastOneCheckbox &&
                !$this.find('input:checked').length
            ) {
                injectMsgs($msgHld, 'danger', [translations.formAlerts.filledAtLeastOne]);
                return;
            } else {
                $msgHld.children().remove();
            }

            $.ajax(ajaxSettings);
        });
    }

    if ($formNewsletter.length) {
        $(document).on('submit', AJAX_FORM_NEWSLETTER_SELECTOR, function (e) {
            e.preventDefault();

            let $this = $(this),
                data = $this.serialize(),
                ajaxSettings = {
                    crossDomain: true,
                    data: data || {},
                    dataType: $this.attr('data-type') || 'json',
                    method: $this.attr('method'),
                    url: $this.attr('action'),
                    success: (data) => {
                        $('#newsletterForm')
                            .find('.js-newsletter-categories-mail')
                                .val($this.find('#newsletterEmail').val())
                            .end()
                            .find('.js-subscribed-categories')
                                .html(data.map((item) => {
                                    return buildSubscriptionCategory(item);
                                }).join(''))
                            .closest('#newsletter').modal('show');
                    }
                };

            if (
                typeof ajaxSettings.method === 'undefined' ||
                typeof ajaxSettings.url === 'undefined'
            ) {
                return;
            }

            $.ajax(ajaxSettings);
        });

    }
}
